module.exports = __webpack_public_path__ + "img/logo_magafilio_branco.eae79848.svg";